<template>
  <el-dialog
    class="select-drug-dialog"
    :visible.sync="showDrugDialog"
    :close-on-press-escape="false"
    :before-close="closeDrugInfo"
    width="1108px"
  >
    <div class="title">
      <span class="text">药品信息</span>
      <i @click="closeDrugInfo(null)" class="el-icon-circle-close"></i>
    </div>
    <div class="drug-info-warp">
      <drug-info
        ref="drugInfo"
        title=""
        :showError="showDrugInfoError"
        :drugInfoList="drugInfoList"
        :options="{ drugUsages, perUnits, units, usageFrequencyNames }"
        :drugWarn="drugWarn"
      ></drug-info>
    </div>
    <div class="footer" slot="footer">
      <el-button
        class="save-drug-btn"
        :class="{ 'save-drug-btn--disabled': !allSave || !drugInfoList.length }"
        type="primary"
        @click="validDrugInfo(saveDrugInfo)"
      >
        确认并提交
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import drugInfo from '@/pages/chooseConsultType/children/applyPrescription/components/drugInfo/index';
import drugInfoMixin from '@/mixins/drugInfo';
import Fetch from '@/api';
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex';
import eventBus, { VIDEO_ACTION } from '@/eventBus';
let timer;
export default {
  components: { drugInfo },
  mixins: [drugInfoMixin],
  data() {
    return {
      show: true
    };
  },
  computed: {
    showDrugDialog: {
      get() {
        return this.$store.state.nwVideo.showDrugDialog;
      },
      set(val) {
        this.SET_SHOW_DRUG_DIALOG(!!val);
      }
    },
    ...mapState('nwVideo', ['nwVideo', 'prescriptionInfo']),
    ...mapGetters('video', ['recordVideoInfoAction']),
    groupId() {
      return this.$route.params.groupId;
    },
    advisoryId() {
      return this.$route.params.advisoryId;
    }
  },
  watch: {
    recordVideoInfoAction(val) {
      console.log('val = ', val);
      if (val === 'connect' && this.nwVideo) {
        this.timerToOpenDrugInfo();
      }
      if (val === 'end' && this.nwVideo && timer) {
        this.showDrugInfoDialog();
      }
    }
  },
  destroyed() {
    window.clearTimeout(timer);
    timer = undefined;
  },
  methods: {
    ...mapMutations('nwVideo', ['SET_NW_VIDEO', 'SET_SHOW_DRUG_DIALOG', 'RESET_STATE']),
    ...mapActions('nwVideo', ['save_drug_info']),
    timerToOpenDrugInfo() {
      console.log('timerToOpenDrugInfo');
      timer = setTimeout(() => {
        console.log('recordVideoInfoAction = ', this.recordVideoInfoAction);
        if (this.recordVideoInfoAction === 'connect') {
          console.log('------- in --------');
          this.showDrugInfoDialog();
        }
      }, 10 * 1000);
    },
    showDrugInfoDialog() {
      window.clearTimeout(timer);
      timer = undefined;
      this.$store.commit('video/SET_SHRINK', true);
      this.SET_SHOW_DRUG_DIALOG(true);
    },
    resetDrugInfo() {
      this.showDrugInfoError = false;
      this.drugInfoList = [];
      this.RESET_STATE();
    },
    closeDrugInfo(done) {
      this.$confirm('关闭选药将会退出咨询，确认退出？', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        customClass: 'confirm',
        center: true
      })
        .then(() => {
          const { advisoryId } = this;
          Fetch.close_advisory(advisoryId).then(res => {
            if (!res) return this.$message.info('结束咨询失败');
            this.resetDrugInfo();
            eventBus.$emit(VIDEO_ACTION.REJECT);
            done && done();
          });
        })
        .catch(err => {
          console.log(err);
        });
    },
    async saveDrugInfo(prescriptionDetails) {
      try {
        await this.save_drug_info(prescriptionDetails);
      } catch (err) {
        console.log('saveDrugInfo err = ', err);
        if (err.code === 'DRUGSTORE_PRESCRIPTION_ERROR_STATUS') {
          this.resetDrugInfo();
          return;
        }
      }

      this.$message.success('你已完成选药');
      this.resetDrugInfo();
      if (this.recordVideoInfoAction === 'connect') {
        this.$nextTick(() => {
          this.$store.commit('video/SET_SHRINK', false);
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog {
  .el-dialog__body {
    padding: 0 20px;
  }
}
.select-drug-dialog {
  .footer {
    text-align: center;
  }
  .save-drug-btn--disabled {
    color: #ffffff;
    background-color: #a2dcad;
    border-color: #a2dcad;
    cursor: not-allowed;
    &:hover,
    &:focus {
      color: #ffffff;
      background-color: #a2dcad;
      border-color: #a2dcad;
    }
  }
  .title {
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .text {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #242424;
      line-height: 44px;
    }
    .el-icon-circle-close {
      font-size: 20px;
      color: #bdbdbd;
      cursor: pointer;
    }
  }
  .drug-info-warp {
    padding: 0 0 20px 0;
    min-height: 450px;
    position: relative;
    max-height: 60vh;
    overflow: auto;
  }
}
</style>
